export interface Rubric {
  requestKey: string;
  name: string;
  createdBy: string;
  dateModified: Date;
  dateModifiedText?: string;
  canEdit: boolean;
  description: string;
  outcomes: RubricOutcome[];
  sharingPreference: string;
}

export interface RubricOutcome {
  requestKey: string;
  name: string;
  description: string;
  tags: string[];
  onePtText: string;
  twoPtText: string;
  threePtText: string;
  fourPtText: string;
  isExpanded?: boolean;
  isDescriptionExpanded?: boolean;
  isScoringCriteriaExpanded?: boolean;
}

export function parseRubric(data: any): Rubric {
  // Parse outcomes if exist
  const outcomes: RubricOutcome[] = [];
  data['outcomes']?.forEach(outcome => {
    outcomes.push({
      requestKey: outcome['requestKey'],
      name: outcome['name'],
      description: outcome['description'],
      tags: outcome['tags'],
      onePtText: outcome['onePtText'] ? outcome['onePtText'] : ScoringCriteriaDefaultTextEnum.OnePtText,
      twoPtText: outcome['twoPtText'] ? outcome['twoPtText'] : ScoringCriteriaDefaultTextEnum.TwoPtText,
      threePtText: outcome['threePtText'] ? outcome['threePtText'] : ScoringCriteriaDefaultTextEnum.ThreePtText,
      fourPtText: outcome['fourPtText'] ? outcome['fourPtText'] : ScoringCriteriaDefaultTextEnum.FourPtText,
    });
  });

  // Create rubric
  const rubric: Rubric = {
    requestKey: data['requestKey'],
    name: data['name'],
    createdBy: data['createdBy'],
    dateModified: new Date(data['dateModified']),
    dateModifiedText: parseDate(data['dateModified']),
    canEdit: data['canEdit'],
    description: data['description'],
    outcomes: outcomes,
    sharingPreference: data['sharingPreference'],
  };

  return rubric;
}

// Convert string to e.g. January 1, 2023 at 01:59 AM
function parseDate(date: any) {
  date = new Date(date);
  const months = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
  ];

  const month = months[date.getMonth()];
  const day = date.getDate();
  const year = date.getFullYear();
  const ampm = formatAMPM(date);

  return `${month} ${day}, ${year} at ${ampm}`;
}

function formatAMPM(date: any) {
  let minutes = date.getMinutes()
  minutes = minutes < 10 ? '0' + minutes : minutes
  return `${(date.getHours() % 12) || 12}:${minutes} ${date.getHours() < 12 ? 'AM' : 'PM'}`
}

export enum SharingPreference {
  Draft = 'draft',
  Private = 'private',
  Public = 'public',
}

export enum RubricMode {
  Create = "create",
  Edit = "edit"
}

export enum ScoringCriteriaDefaultTextEnum {
  OnePtText = 'Needs Attention',
  TwoPtText = 'Adequate',
  ThreePtText = 'Very Good',
  FourPtText = 'Excellent',
}
